import type { LocaleKey } from './ArcRegistry';

/**
 * Minimal localization stub. All user-facing strings route through L(key).
 * When the full i18n system lands, this becomes a language-aware lookup.
 * For now: a global bundle merged from registered arcs.
 */
export class Locale {
  private readonly bundle = new Map<LocaleKey, string>();
  private fallbackLocale = 'en';

  register(bundle: Record<LocaleKey, string> | undefined): void {
    if (!bundle) return;
    for (const [k, v] of Object.entries(bundle)) {
      this.bundle.set(k, v);
    }
  }

  t(key: LocaleKey, params?: Record<string, string | number>): string {
    const raw = this.bundle.get(key) ?? `[${key}]`;
    if (!params) return raw;
    return raw.replace(/\{(\w+)\}/g, (_m, name: string) =>
      String(params[name] ?? `{${name}}`),
    );
  }

  has(key: LocaleKey): boolean {
    return this.bundle.has(key);
  }

  clear(): void {
    this.bundle.clear();
  }

  get locale(): string {
    return this.fallbackLocale;
  }
}

// Singleton instance — one per running game
export const locale = new Locale();

/** Short alias. `L('narrator.intro')`. */
export function L(key: LocaleKey, params?: Record<string, string | number>): string {
  return locale.t(key, params);
}
